import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { COMPANY } from "../data/insurances";

export default function AboutPage() {
  return (
    <div data-testid="about-page">
      {/* Hero */}
      <section className="bg-gradient-to-br from-white via-white to-navy-50 py-20 md:py-28 relative overflow-hidden">
        <div className="absolute inset-0 brick-grid-bg opacity-50" />
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl relative text-center">
          <p className="text-lego text-sm font-bold uppercase tracking-widest mb-4">Sobre a Safe Life</p>
          <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-extrabold text-navy leading-[1.05] tracking-tight">
            Proteger a vida é,<br />
            <span className="font-serif-accent italic text-lego">acima de tudo, um ato de amor.</span>
          </h1>
          <p className="mt-8 text-lg text-navy/70 leading-relaxed max-w-2xl mx-auto">
            A Safe Life nasceu com um propósito simples: fazer do seguro algo humano, acessível e confiável.
          </p>
        </div>
      </section>

      {/* Story */}
      <section className="py-16 md:py-20">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-3xl">
          <div className="prose prose-lg max-w-none text-navy/80 leading-relaxed space-y-6">
            <p className="text-2xl font-serif-accent italic text-navy">
              "Nosso símbolo nasceu dentro de casa. Um coração construído com LEGO pelo filho de um dos sócios. Porque para nós, proteger a vida é algo pessoal."
            </p>
            <p>
              Existimos para mudar a forma como as pessoas enxergam seguros no Brasil. Sabemos que contratar um seguro muitas vezes é burocrático, confuso e frio. Com a Safe Life, queremos mostrar que pode ser diferente.
            </p>
            <p>
              Nosso trabalho é comparar as melhores seguradoras do mercado, explicar cada cobertura com clareza e acompanhar você em cada momento — da cotação ao sinistro. Sem letras miúdas, sem promessas vazias.
            </p>
            <p>
              Atuamos em todo o Brasil, a partir da nossa sede em Jales/SP, com uma equipe comprometida em construir relacionamentos duradouros. Assim como um coração de LEGO, feito de pequenas peças que se encaixam: cada detalhe importa.
            </p>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-16 md:py-20 bg-surface">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl">
          <h2 className="font-heading text-3xl md:text-4xl font-extrabold text-navy text-center mb-12">
            Nossos valores
          </h2>
          <div className="grid md:grid-cols-3 gap-6">
            {[
              { icon: "fa-heart", title: "Humanidade", desc: "Atendimento consultivo, próximo e sem scripts. Você é chamado pelo nome." },
              { icon: "fa-handshake", title: "Transparência", desc: "Explicamos cada cobertura. Você assina sabendo exatamente o que está contratando." },
              { icon: "fa-shield-heart", title: "Compromisso", desc: "Do primeiro contato ao sinistro, estamos com você. Aqui não é sobre vender. É sobre cuidar." },
            ].map((v) => (
              <div key={v.title} className="bg-white rounded-3xl p-8 border border-navy-100">
                <div className="w-14 h-14 bg-lego/10 rounded-2xl flex items-center justify-center mb-5">
                  <i className={`fa-solid ${v.icon} text-lego text-xl`} />
                </div>
                <h3 className="font-heading text-xl font-bold text-navy mb-2">{v.title}</h3>
                <p className="text-sm text-navy/70 leading-relaxed">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-navy text-white relative overflow-hidden">
        <div className="absolute inset-0 brick-pattern opacity-30" />
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-3xl text-center relative">
          <h2 className="font-heading text-3xl md:text-4xl font-extrabold">
            Vamos construir juntos?
          </h2>
          <p className="mt-4 text-white/80">
            Cote seu seguro com a Safe Life e descubra a diferença do cuidado humano.
          </p>
          <Button
            asChild
            size="lg"
            className="mt-8 bg-brand hover:bg-brand-600 active:bg-brand-700 text-white rounded-full font-bold h-14 px-8"
            data-testid="about-cta-cotar"
          >
            <Link to="/cotacao">Fazer cotação grátis</Link>
          </Button>
          <p className="mt-10 text-xs text-white/50">
            {COMPANY.name} — CNPJ {COMPANY.cnpj} — SUSEP {COMPANY.susep}
          </p>
        </div>
      </section>
    </div>
  );
}
